<template>
    <div class="card border-0 mt-5">
        <div class="card-body font-weight-bold fs-7" style="line-height: 1.3">
            <div class="row align-items-center gy-4 gx-5">
                <div class="col-lg-8">
                    <div class="text-center">
                        <div class="row align-items-center gy-3">
                            <div class="col-md">
                                <router-link :to="{ name: 'list' }" custom v-slot="{ href, navigate }">
                                    <a :href="href" @click="navigate">
                                        formations<br>
                                        rencontres<br>
                                        parcours
                                    </a>
                                </router-link>
                            </div>
                            <div class="col-auto d-none d-md-block">
                                <Icon name="arrow-right" class="text-primary" width="1rem" height="1rem" />
                            </div>
                            <div class="col-md">
                                <template v-for="item in items.slice(0, 3)">
                                    <div class="mb-1">
                                        <a class="text-reset" :href="item.url">{{ item.label }}</a>
                                    </div>
                                </template>
                            </div>
                            <div class="col-auto d-none d-md-block">
                                <Icon name="arrow-right" class="text-primary" width="1rem" height="1rem" />
                            </div>
                            <div class="col-md">
                                <template v-for="item in items.slice(3)">
                                    <div class="mb-1">
                                        <a class="text-reset" :href="item.url">{{ item.label }}</a>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Icon from "./Icon";
  import { baseUrl } from "../../util/config";

  export default {
        components: {
            Icon,
        },
        props: {
            items: Array,
        },
        methods: {
            baseUrl,
        },
    }
</script>
